import React, { useEffect, useState } from 'react';
import ImageUpload from './ImageUpload';
import Topbar from '../Topbar';
import { auth, db } from '../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import '../tools.css';
import { useNavigate } from 'react-router-dom';
import { Circles } from 'react-loader-spinner';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { getAllSessions } from '../../indexedDB';

const ToolCanineTeeth = () => {
  const [user, setUser] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [isAuthLoading, setIsAuthLoading] = useState(true);
  const [annotationSessions, setAnnotationSessions] = useState([]);
  const [currentSessionIndex, setCurrentSessionIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUser(user);
        const docRef = doc(db, 'users', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setUserInfo(docSnap.data());
        }
        // Carica tutte le sessioni per l'utente (da IndexedDB)
        const sessions = await getAllSessions(user.email);
        // Filtra solo quelle per il tool "canine-teeth-ai" (se necessario)
        const filteredSessions = sessions.filter(
          (session) => session.tool === 'canine-teeth-ai'
        );
        // Ordina le sessioni per timestamp (crescente)
        filteredSessions.sort(
          (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
        );
        setAnnotationSessions(filteredSessions);
      } else {
        setUser(null);
        navigate('/');
      }
      setIsAuthLoading(false);
    });

    return () => unsubscribe();
  }, [navigate]);

  const handlePrev = () => {
    setCurrentSessionIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setCurrentSessionIndex((prev) =>
      Math.min(prev + 1, annotationSessions.length - 1)
    );
  };

  if (isAuthLoading) {
    return (
      <div className="loading-overlay">
        <div className="loading-content">
          <Circles height="80" width="80" color="#ffffff" ariaLabel="loading" />
          <p>Loading... Syncing profile info</p>
        </div>
      </div>
    );
  }

  return (
    <div className="tool-container">
      {user && userInfo && <Topbar userInfo={userInfo} user={user} />}
      <h2 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {annotationSessions.length > 0 && (
          <button
            onClick={handlePrev}
            disabled={currentSessionIndex === 0}
            style={{ background: 'none', border: 'none', cursor: 'pointer', marginRight: '10px' }}
            title="Previous annotation"
          >
            <FaArrowLeft size={24} />
          </button>
        )}
        Age Estimation in Adults by single-rooted teeth
        {annotationSessions.length > 0 && (
          <button
            onClick={handleNext}
            disabled={currentSessionIndex === annotationSessions.length - 1}
            style={{ background: 'none', border: 'none', cursor: 'pointer', marginLeft: '10px' }}
            title="Next annotation"
          >
            <FaArrowRight size={24} />
          </button>
        )}
      </h2>
      {user ? (
        // Passa la sessione corrente come prop loadedSession a ImageUpload
        <ImageUpload loadedSession={annotationSessions[currentSessionIndex]} />
      ) : (
        <div>Please log in to use this tool.</div>
      )}
    </div>
  );
};

export default ToolCanineTeeth;
